import {
  createFrontendModule,
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';

// Tradução PT-BR (parcial) do plugin de catálogo. `full: false` faz as chaves
// não traduzidas caírem no idioma padrão do ref (inglês). Escopo: páginas de
// Catálogo (índice + entidade). Outros plugins ficam para um passo futuro.

const catalogMessagesPt = createTranslationMessages({
  ref: catalogTranslationRef,
  full: false,
  messages: {
    'indexPage.title': 'Catálogo {{orgName}}',
    'indexPage.createButtonTitle': 'Criar',
    'indexPage.supportButtonContent':
      'Todas as entidades do seu catálogo de software',
    'aboutCard.title': 'Sobre',
    'aboutCard.refreshButtonTitle': 'Agendar atualização da entidade',
    'aboutCard.editButtonTitle': 'Editar metadados',
    'aboutCard.createSimilarButtonTitle': 'Criar algo semelhante',
    'aboutCard.refreshScheduledMessage': 'Atualização agendada',
    'aboutCard.launchTemplate': 'Abrir template',
    'aboutCard.viewTechdocs': 'Ver TechDocs',
    'aboutCard.viewSource': 'Ver código-fonte',
    'aboutCard.unknown': 'desconhecido',
    'aboutCard.descriptionField.label': 'Descrição',
    'aboutCard.descriptionField.value': 'Sem descrição',
    'aboutCard.ownerField.label': 'Responsável',
    'aboutCard.ownerField.value': 'Sem responsável',
    'aboutCard.domainField.label': 'Domínio',
    'aboutCard.domainField.value': 'Sem domínio',
    'aboutCard.systemField.label': 'Sistema',
    'aboutCard.systemField.value': 'Sem sistema',
    'aboutCard.parentComponentField.label': 'Componente pai',
    'aboutCard.parentComponentField.value': 'Sem componente pai',
    'aboutCard.kindField.label': 'Categoria',
    'aboutCard.typeField.label': 'Tipo',
    'aboutCard.lifecycleField.label': 'Ciclo de vida',
    'aboutCard.tagsField.label': 'Etiquetas',
    'aboutCard.tagsField.value': 'Sem etiquetas',
    'aboutCard.targetsField.label': 'Alvos',
    'searchResultItem.kind': 'Categoria',
    'searchResultItem.type': 'Tipo',
    'searchResultItem.lifecycle': 'Ciclo de vida',
    'searchResultItem.owner': 'Responsável',
    'catalogTable.warningPanelTitle':
      'Não foi possível carregar as entidades do catálogo.',
    'catalogTable.viewActionTitle': 'Ver',
    'catalogTable.editActionTitle': 'Editar',
    'catalogTable.starActionTitle': 'Adicionar aos favoritos',
    'catalogTable.unStarActionTitle': 'Remover dos favoritos',
    'catalogTable.allFilters': 'Todos',
    'dependencyOfComponentsCard.title': 'Dependência de componentes',
    'dependencyOfComponentsCard.emptyMessage':
      'Nenhum componente depende deste componente.',
    'dependsOnComponentsCard.title': 'Depende de componentes',
    'dependsOnComponentsCard.emptyMessage':
      'Este componente não depende de nenhum componente.',
    'dependsOnResourcesCard.title': 'Depende de recursos',
    'dependsOnResourcesCard.emptyMessage':
      'Este componente não depende de nenhum recurso.',
    'hasComponentsCard.title': 'Componentes',
    'hasComponentsCard.emptyMessage': 'Nenhum componente faz parte deste sistema.',
    'hasResourcesCard.title': 'Recursos',
    'hasResourcesCard.emptyMessage': 'Nenhum recurso faz parte deste sistema.',
    'hasSubcomponentsCard.title': 'Subcomponentes',
    'hasSubcomponentsCard.emptyMessage':
      'Nenhum subcomponente faz parte deste componente.',
    'hasSubdomainsCard.title': 'Subdomínios',
    'hasSubdomainsCard.emptyMessage': 'Nenhum subdomínio faz parte deste domínio.',
    'hasSystemsCard.title': 'Sistemas',
    'hasSystemsCard.emptyMessage': 'Nenhum sistema faz parte deste domínio.',
    'relatedEntitiesCard.emptyHelpLinkTitle': 'Saiba como alterar isto.',
    'entityContextMenu.copiedMessage': 'Copiado!',
    'entityContextMenu.moreButtonTitle': 'Mais',
    'entityContextMenu.inspectMenuTitle': 'Inspecionar entidade',
    'entityContextMenu.copyURLMenuTitle': 'Copiar URL da entidade',
    'entityContextMenu.unregisterMenuTitle': 'Cancelar registro da entidade',
    'entityLabelsCard.title': 'Rótulos',
    'entityLinksCard.title': 'Links',
  },
});

const catalogReactMessagesPt = createTranslationMessages({
  ref: catalogReactTranslationRef,
  full: false,
  messages: {
    'catalogFilter.title': 'Filtros',
    'catalogFilter.buttonTitle': 'Filtros',
    'entityKindPicker.title': 'Categoria',
    'entityLifecyclePicker.title': 'Ciclo de vida',
    'entityNamespacePicker.title': 'Namespace',
    'entityOwnerPicker.title': 'Responsável',
    'entityProcessingStatusPicker.title': 'Status de processamento',
    'entityTagPicker.title': 'Etiquetas',
    'entitySearchBar.placeholder': 'Buscar',
    'entityTypePicker.title': 'Tipo',
    'entityTypePicker.optionAllTitle': 'todos',
    'favoriteEntity.addToFavorites': 'Adicionar aos favoritos',
    'favoriteEntity.removeFromFavorites': 'Remover dos favoritos',
    'userListPicker.defaultOrgName': 'Empresa',
    'userListPicker.personalFilter.title': 'Pessoal',
    'userListPicker.personalFilter.ownedLabel': 'Meus',
    'userListPicker.personalFilter.starredLabel': 'Favoritos',
    'userListPicker.orgFilterAllLabel': 'Todos',
    'entityTableColumnTitle.name': 'Nome',
    'entityTableColumnTitle.system': 'Sistema',
    'entityTableColumnTitle.owner': 'Responsável',
    'entityTableColumnTitle.type': 'Tipo',
    'entityTableColumnTitle.lifecycle': 'Ciclo de vida',
    'entityTableColumnTitle.namespace': 'Namespace',
    'entityTableColumnTitle.description': 'Descrição',
    'entityTableColumnTitle.tags': 'Etiquetas',
    'entityTableColumnTitle.targets': 'Alvos',
    'entityTableColumnTitle.title': 'Título',
    'entityTableColumnTitle.label': 'Rótulo',
    'entityTableColumnTitle.domain': 'Domínio',
    'entityRelationCard.emptyHelpLinkTitle': 'Saiba como alterar isto.',
  },
});

const catalogTranslationPt = TranslationBlueprint.make({
  name: 'catalog-pt-br',
  params: {
    resource: createTranslationResource({
      ref: catalogTranslationRef,
      translations: {
        pt: () => Promise.resolve({ default: catalogMessagesPt }),
      },
    }),
  },
});

const catalogReactTranslationPt = TranslationBlueprint.make({
  name: 'catalog-react-pt-br',
  params: {
    resource: createTranslationResource({
      ref: catalogReactTranslationRef,
      translations: {
        pt: () => Promise.resolve({ default: catalogReactMessagesPt }),
      },
    }),
  },
});

export const i18nModule = createFrontendModule({
  pluginId: 'app',
  extensions: [catalogTranslationPt, catalogReactTranslationPt],
});
